import type { ApplicationApplicantType } from "@libs/api/patients";

export const getApplicantFirstNames = (
  applicants: ApplicationApplicantType[],
): string[] => {
  const seenHouseholdMemberIds = new Set<string>();

  return applicants.flatMap(applicant => {
    if (seenHouseholdMemberIds.has(applicant.householdMemberId)) return [];

    seenHouseholdMemberIds.add(applicant.householdMemberId);
    return [applicant.firstName];
  });
};
